import { KeyDown } from './keyDown';

const escapeDown = new KeyDown('Escape');
const enterDown = new KeyDown('Enter');

export { enterDown, escapeDown };
